var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { RadioChecked, RadioEmpty } from 'pcln-icons';
import { applyVariations, deprecatedColorValue, getPaletteColor } from '../utils';
var RadioWrap = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  color: ", ";\n  &:hover > svg {\n    ", ";\n  }\n  ", "\n"], ["\n  display: inline-block;\n  color: ", ";\n  &:hover > svg {\n    ", ";\n  }\n  ", "\n"])), getPaletteColor('border.base'), function (props) {
    if (props.checked && !props.disabled) {
        return "color: ".concat(getPaletteColor('dark')(props), " !important;");
    }
    return props.disabled ? null : "color: ".concat(getPaletteColor('base')(props), ";");
}, applyVariations('Radio'));
var RadioInput = styled.input(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  appearance: none;\n  opacity: 0;\n  position: absolute;\n  z-index: 0;\n\n  & ~ svg {\n    border: 1px solid transparent;\n    border-radius: 50%;\n    padding: 2px;\n  }\n\n  &:focus {\n    box-shadow: none;\n    & ~ svg {\n      border: 1px solid ", ";\n      background-color: ", ";\n    }\n  }\n  &:checked ~ svg {\n    color: ", ";\n  }\n  &:disabled ~ svg {\n    color: ", ";\n  }\n"], ["\n  appearance: none;\n  opacity: 0;\n  position: absolute;\n  z-index: 0;\n\n  & ~ svg {\n    border: 1px solid transparent;\n    border-radius: 50%;\n    padding: 2px;\n  }\n\n  &:focus {\n    box-shadow: none;\n    & ~ svg {\n      border: 1px solid ", ";\n      background-color: ", ";\n    }\n  }\n  &:checked ~ svg {\n    color: ", ";\n  }\n  &:disabled ~ svg {\n    color: ", ";\n  }\n"])), getPaletteColor('border.base'), getPaletteColor('background.light'), getPaletteColor('base'), getPaletteColor('border.base'));
var RadioCheckedIcon = styled(RadioChecked)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  vertical-align: middle;\n"], ["\n  vertical-align: middle;\n"])));
var RadioEmptyIcon = styled(RadioEmpty)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  vertical-align: middle;\n"], ["\n  vertical-align: middle;\n"])));
var RadioIcon = function (_a) {
    var checked = _a.checked, props = __rest(_a, ["checked"]);
    return checked ? React.createElement(RadioCheckedIcon, __assign({}, props)) : React.createElement(RadioEmptyIcon, __assign({}, props));
};
RadioIcon.propTypes = {
    checked: PropTypes.bool,
};
var propTypes = {
    color: deprecatedColorValue(),
    size: PropTypes.number,
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
};
var Radio = React.forwardRef(function (props, ref) {
    var checked = props.checked, disabled = props.disabled, size = props.size;
    var borderAdjustedSize = size + 4;
    return (React.createElement(RadioWrap, { color: props.color, checked: checked, disabled: disabled },
        React.createElement(RadioInput, __assign({ type: 'radio' }, props, { ref: ref })),
        React.createElement(RadioIcon, { checked: checked, size: borderAdjustedSize })));
});
Radio.displayName = 'Radio';
Radio.propTypes = propTypes;
Radio.defaultProps = {
    color: 'primary',
    size: 24,
};
export default Radio;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=Radio.js.map